export default "__VITE_ASSET__DXM$Ddgo__"